import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileTimePicker } from "@mui/x-date-pickers/MobileTimePicker";
import dayjs from "dayjs";
import React from "react";
import clockIcon from "../../../images/time-outline.svg";

interface PlanificationMethodProps {
  isMaintenantChecked: boolean;
  handlePlanificationMethodChange: (
    e: React.ChangeEvent<HTMLInputElement>
  ) => void;
  tempsPreparation: string | undefined;
  OpenTime: dayjs.Dayjs;
  ClosedTime: dayjs.Dayjs;
  pickedTime: dayjs.Dayjs;
  handleTimeChange: (newValue: dayjs.Dayjs | null) => void;
}

const PlanificationMethod: React.FC<PlanificationMethodProps> = ({
  isMaintenantChecked,
  handlePlanificationMethodChange,
  tempsPreparation,
  OpenTime,
  ClosedTime,
  pickedTime,
  handleTimeChange,
}) => {
  return (
    <div className="payment-methode-container show-card">
      <p className="block-title">Méthode de Planification</p>
      <div
        className="second-Input"
        style={{
          gap: "15px",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <div className="onsite-payment payment-methode-field">
          <input
            type="radio"
            name="payment-planification"
            id="maintenant"
            value="maintenant"
            checked={!isMaintenantChecked}
            onChange={handlePlanificationMethodChange}
          />
          <label htmlFor="maintenant">Maintenant</label>
          {!isMaintenantChecked && (
            <div style={{ paddingLeft: "30px" }}>
              <p>Prête dans : {tempsPreparation} min</p>
            </div>
          )}
        </div>
        <div className="onsite-payment payment-methode-field">
          <input
            type="radio"
            name="payment-planification"
            id="planifier"
            value="planifier"
            checked={isMaintenantChecked}
            onChange={handlePlanificationMethodChange}
          />
          <label htmlFor="planifier">Planifier</label>
          {isMaintenantChecked && (
            <div className="chechkingg">
              <p>
                Horaire : {OpenTime.format("HH:mm")} à{" "}
                {ClosedTime.format("HH:mm")}
              </p>
              <div className="field-time">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["MobileTimePicker"]}>
                    <DemoItem>
                      <MobileTimePicker
                        value={pickedTime} //change the name to signifcatif name
                        onChange={handleTimeChange}
                        ampm={false}
                      />
                    </DemoItem>
                  </DemoContainer>
                </LocalizationProvider>
                <img src={clockIcon} alt="Clock" />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PlanificationMethod;
